module.exports = __webpack_public_path__ + "img/logorobotpregunta.294288d6.jpg";